export default "__VITE_ASSET__5$4r_Dzi__"